<template>
  <div
        class="right-drawer"
        :style="{
          width: drawerVisible ? '100%' : '0',
          paddingLeft: drawerVisible ? '0' : '0',
        }"
      >
        <table style="width: 100%; background: #fff">
          <tr style="width: 100%">
           
          </tr>
        </table>
  
        <!-- merchantIndex -->
        <ais-instant-search
          :search-client="searchClient"
          index-name="development_api::merchant-web.merchant-web"
          :stalled-search-delay="500"
          style="margin-left: 2%; margin-right: 2%"
          :routing="routing"
          :insights="true"
        >
          <!-- <app-debounced-search-box :delay="700" /> -->
          
  
          <div class="search-input-parent">
            <img
                class="arrow-left-icon"
                loading="lazy"
                alt=""
                @click="closeSearchDrawer"
                src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Koko-search/close1.png"
              />
            <div class="search-bar-container">
            
            <div class="search-input">
              <div class="search-input-child" />
              <div class="frame-div">
                <Autocomplete />
                
              </div>
            </div>
              <div class="union-wrapper">
                <!-- <img class="union-icon" loading="lazy" alt="" src="/union@2x.png" /> -->
              </div>
            </div>
          
          </div>
  
       
  
          <div class="rectanguler" v-show="showFilter">
            <SearchFilter :showFilterProp="showFilter" @update:showFilterProp="updateShowFilter"/>
          </div>
          <ais-state-results>
            <template  v-slot="{ results: {  query, hits } }">
              <div  >
            <SearchResultSort v-if="hits.length > 0 && query.length > 0"/>
          </div>
            </template>
          </ais-state-results>
          
          <!-- No results -->
          <NoSearchResults/>
  
          <!-- static page -->
          <SearchStaticPage/>
  
         
       <ais-configure :hits-per-page.camel="6" />
       <ais-state-results>
            <template #default="{ results: { query } }">
      <div class="ais-hits-parent">
      <div class="frame-section">
          <div class="frame-parent1">
  
          
            <ais-infinite-hits v-show="query.length > 0">
            
              
              <template v-slot:item="{ item }">
                <!-- <div>{{item.merchantName}}</div> -->
              <a :href="'/m/merchant/' + item.id">
                <div class="rectangle-group" :style="groupDivStyle"  v-if=item.publishedAt>
                  <img class="frame-inner" alt="" :src="rectangle3" />
                  
                  <img 
          v-if="item.rectBannerUrl == null"
          :src="item.rectBannerLink"
          class="rectangle-div">
          <img 
          v-else
          :src="item.rectBannerUrl.url"
          class="rectangle-div">
          
                <div class="up-to-off-instance">
                  <div
                    :class="[
                      item.merchantDiscount && isDiscountValid(item.discountStartDate, item.discountEndDate)
                        ? 'shopping-bag-instance'
                        : 'shopping-bag-instance-blank',
                    ]"
                  >
                    <b class="up-to-40" v-if="isDiscountValid(item.discountStartDate, item.discountEndDate)">
                      {{ item.merchantDiscount }}
                    </b>
                  </div>
                </div>
                  <div class="stripes-checks-instance">
                    
                    
                  </div>
                  <div class="frame-parent14">
                    <div class="frame-wrapper9">
                      <div class="shopping-bag-parent">
                        <img
                          class="shopping-bag-icon"
                          alt=""
                          src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Koko-search/Shopping%20Bag.png"
                        />
                        <div class="instore-online">
                        <div class="instore-online-child" v-if="item.doesOffline">
                            Instore
                          </div>
                          <div  class="instore-online-child"
                          v-if="item.doesOnline && item.doesSocial && item.doesOffline">  , </div>
                          <div class="instore-online-child" v-if="item.doesOnline && !item.doesSocial && item.doesOffline"
                          > & </div>
                        <div class="instore-online-child"  v-if="item.doesOnline">
                            Online
                          </div>
                          <div class="instore-online-child" 
                          v-if="(item.doesOnline && item.doesSocial && item.doesOffline)||(!item.doesOnline && item.doesSocial && item.doesOffline)||(item.doesOnline && item.doesSocial && !item.doesOffline)">&  </div>
                          <div class="instore-online-child" v-if="item.doesSocial">
                            Social Media
                          </div>
                        </div>
                          
                      </div>
                    </div>
                    <div class="rectangle-container">
                      <div class="frame-child1" />
                      
                      <div class="stripes-checks">{{ item.merchantName }}</div>
                    </div>
                  </div>
                </div>
              </a>
             
            </template>
          
        </ais-infinite-hits>
        </div>
                </div>
              </div>
              </template>
            </ais-state-results>
        </ais-instant-search>
    
      </div>
</template>

<script>
import { singleIndex } from "instantsearch.js/es/lib/stateMappings";
import { history } from "instantsearch.js/es/lib/routers";
import { INSTANT_SEARCH_INDEX_NAME } from "../components/search_utils/constants";
import SearchFilter from "../components/SearchFilter.vue";
import { searchClient } from "../components/search_utils/searchClient";
import Autocomplete from "../components/Autocomplete.vue";
import NoSearchResults from "../components/NoSearchResults.vue";
import SearchResultSort from "../components/SearchResultSort.vue";
import SearchStaticPage from "../components/SearchStaticPage.vue";
import { AisInstantSearch, AisStateResults,AisInfiniteHits,AisConfigure } from 'vue-instantsearch/vue3/es';
import { isDiscountValid } from '../utils/discountUtils';
import "../assets/css/search.css";

export default {
  name: "SearchDrawer",
  components:{
      Autocomplete,
      SearchFilter,
      NoSearchResults,
      SearchResultSort,
      SearchStaticPage,
      AisInstantSearch,
      AisStateResults,
      AisInfiniteHits,
      AisConfigure
  },
  props: {
    drawerVisible:{
      type:Boolean,
      default:()=>false
    },
    closeSearchDrawer:{
      type:Function
    }
  },
  data() {
    return {
      searchClient,
      showFilter: false,
      routing: {
          router: history(),
          stateMapping: singleIndex(INSTANT_SEARCH_INDEX_NAME),
        }
    };
  },
  computed: {
    
  },
  created() {
    
  },
  methods:{
    isDiscountValid,
    updateShowFilter(value) {
        this.showFilter = value;
      },
  },
};
</script>

<style scoped>
a{
  text-decoration: none;
}
.aisSearchBox {
    font-size: 2px;
    color: red;
    border-radius: 16px;
  }
  .aisSearchForm {
    font-size: 2px;
    color: red;
    border-radius: 16px;
  }
  .aisSearchInput {
    font-size: 2px;
    color: red;
    border-radius: 16px;
  }
  
  
  </style>